"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpreadSide = exports.CoverageType = void 0;
exports.default = getCoverageType;
var CoverageType;
(function (CoverageType) {
  CoverageType["FULL"] = "full";
  CoverageType["LEFT"] = "left";
  CoverageType["RIGHT"] = "right";
})(CoverageType || (exports.CoverageType = CoverageType = {}));
var SpreadSide;
(function (SpreadSide) {
  SpreadSide["LEFT"] = "left";
  SpreadSide["RIGHT"] = "right";
})(SpreadSide || (exports.SpreadSide = SpreadSide = {}));
function getCoverageType(printable, layerId) {
  if (printable.isCompositeDesign) {
    const layer = printable.layers.find(layer => layer.id === layerId);
    if (layer) {
      return layer.x + layer.width / 2 >= 0.5 ? CoverageType.RIGHT : CoverageType.LEFT;
    }
    return !(layerId === null || layerId === void 0 ? void 0 : layerId.includes('--SHIFTED')) ? CoverageType.LEFT : CoverageType.RIGHT;
  }
  return CoverageType.FULL;
}